import { escapeHtml, formatAdditionalFamilyEntry } from '@messenger/utils'

type FamilyEntry = {
  name?: string | null
  relation?: string | null
  type?: string | null
  // Rows carry more columns (city/state/country, audit fields) — only the
  // fields above are rendered.
  [key: string]: unknown
}

/**
 * One <p> line per family member ("Name, Relation" — name and relation
 * only, matching the flat input). Uses the same display helper as the
 * sidebar list, so the inserted block, its dynamic re-renders, and the
 * on-screen list always agree (including the legacy type-as-relation
 * fallback for pre-consolidation rows). Re-renders rebuild from raw case
 * data each pass, so escaping never compounds.
 */
export const buildAdditionalFamilyContent = (
  items: FamilyEntry[] | null | undefined,
): string =>
  (items ?? [])
    .map((item) => formatAdditionalFamilyEntry(item))
    .filter(Boolean)
    // Family names and relations are plain text: escaped, markup in a value
    // is shown as text, never run.
    .map((line) => `<p>${escapeHtml(line)}</p>`)
    .join('')

export default buildAdditionalFamilyContent
